/* eslint-disable import/prefer-default-export */

export const GET_MERCHANT_PROFILE = "GET_MERCHANT_PROFILE";
export const GET_MERCHANT_PROFILE_ERROR = "GET_MERCHANT_PROFILE_ERROR";
export const CREATE_MERCHANT_PROFILE_SUCCESS =
  "CREATE_MERCHANT_PROFILE_SUCCESS";
export const CREATE_MERCHANT_PROFILE_FAILED = "CREATE_MERCHANT_PROFILE_FAILED";
export const CREATE_MERCHANT_PROFILE_PENDING =
  "CREATE_MERCHANT_PROFILE_PENDING";
export const EDIT_MERCHANT_PROFILE_SUCCESS = "EDIT_MERCHANT_PROFILE_SUCCESS";
export const EDIT_MERCHANT_PROFILE_FAILED = "EDIT_MERCHANT_PROFILE_FAILED";
export const EDIT_MERCHANT_PROFILE_PENDING = "EDIT_MERCHANT_PROFILE_PENDING";
